import React from 'react';
import './components.css';
import Publication from './single_publication';


function Publications(){
    var json = require('../data/data.json');
    return(
        <section className='tile tile-papers' id='publications'>
            <h2 className='tile-label'>Papers ✍️</h2>
            <div className='publication-list'>
                {json['publications'].map(x => (
                    <Publication publication={x} key={x.id} />
                ))}
            </div>
        </section>
    )
}

export default Publications;
